import { DEMO_EMPLOYEE } from "../lib/roles";
import {
  DOMAIN_OWNERS,
  GOVSUITE_SUPPORT,
  hoursAgo,
  type HelpDeskTicket,
} from "../lib/helpdesk";

const openedIt = hoursAgo(52);
const acceptedIt = hoursAgo(40);
const openedFac = hoursAgo(18);
const openedFin = hoursAgo(30);
const rerouteFin = hoursAgo(26);
const openedBug = hoursAgo(72);
const acceptedBug = hoursAgo(60);
const escalatedBug = hoursAgo(36);

export const SEED_HELP_TICKETS: HelpDeskTicket[] = [
  {
    id: "hd-1",
    subject: "VPN drops on hotel wifi",
    body: "VPN disconnects every few minutes on hotel wifi during travel.",
    category: "IT",
    status: "In progress",
    tier: 1,
    requester_id: DEMO_EMPLOYEE.id,
    requester_email: DEMO_EMPLOYEE.email,
    requester_name: DEMO_EMPLOYEE.name,
    assignee_id: DOMAIN_OWNERS.IT.employee_id,
    assignee_name: DOMAIN_OWNERS.IT.name,
    opened_at: openedIt,
    accepted_at: acceptedIt,
    route_history: [
      {
        at: openedIt,
        kind: "assigned",
        from_name: DEMO_EMPLOYEE.name,
        to_name: DOMAIN_OWNERS.IT.name,
        reason: "IT domain owner",
      },
      {
        at: acceptedIt,
        kind: "accept",
        from_name: DOMAIN_OWNERS.IT.name,
        to_name: DOMAIN_OWNERS.IT.name,
        reason: "Accepted — desktop support investigating hotel wifi MTU.",
      },
    ],
  },
  {
    id: "hd-2",
    subject: "Need badge reprint for building B",
    body: "Badge reader will not accept my card at building B.",
    category: "Facilities",
    status: "Submitted",
    tier: 1,
    requester_id: DEMO_EMPLOYEE.id,
    requester_email: DEMO_EMPLOYEE.email,
    requester_name: DEMO_EMPLOYEE.name,
    assignee_id: DOMAIN_OWNERS.Facilities.employee_id,
    assignee_name: DOMAIN_OWNERS.Facilities.name,
    opened_at: openedFac,
    route_history: [
      {
        at: openedFac,
        kind: "assigned",
        from_name: DEMO_EMPLOYEE.name,
        to_name: DOMAIN_OWNERS.Facilities.name,
        reason: "Facilities domain owner",
      },
    ],
  },
  {
    id: "hd-3",
    subject: "HFS-1001 burn rate question",
    body: "Need clarification on project finance burn rate vs funded ceiling for NOAA Coastal Sensors.",
    category: "Finance",
    status: "Submitted",
    tier: 1,
    requester_id: DEMO_EMPLOYEE.id,
    requester_email: DEMO_EMPLOYEE.email,
    requester_name: DEMO_EMPLOYEE.name,
    assignee_id: "emp-blake",
    assignee_name: "Morgan Blake",
    project_id: "prj-1",
    project_code: "HFS-1001",
    opened_at: openedFin,
    route_history: [
      {
        at: openedFin,
        kind: "assigned",
        from_name: DEMO_EMPLOYEE.name,
        to_name: "Morgan Blake",
        reason: "Project finance assignee for HFS-1001",
      },
      {
        at: rerouteFin,
        kind: "reroute",
        from_name: "Morgan Blake",
        to_name: "Jordan Ortiz",
        reason: "Re-routed to project PM for funding context (demo hop).",
      },
    ],
  },
  {
    id: "hd-4",
    subject: "Timesheet grid freezes on submit",
    body: "GovSuite timesheet page freezes when certifying — looks like a product bug.",
    category: "IT",
    status: "In progress",
    tier: 2,
    requester_id: DEMO_EMPLOYEE.id,
    requester_email: DEMO_EMPLOYEE.email,
    requester_name: DEMO_EMPLOYEE.name,
    assignee_id: GOVSUITE_SUPPORT.employee_id,
    assignee_name: GOVSUITE_SUPPORT.name,
    opened_at: openedBug,
    accepted_at: acceptedBug,
    route_history: [
      {
        at: openedBug,
        kind: "assigned",
        from_name: DEMO_EMPLOYEE.name,
        to_name: DOMAIN_OWNERS.IT.name,
        reason: "IT domain owner",
      },
      {
        at: acceptedBug,
        kind: "accept",
        from_name: DOMAIN_OWNERS.IT.name,
        to_name: DOMAIN_OWNERS.IT.name,
        reason: "Reproduced locally — product defect.",
      },
      {
        at: escalatedBug,
        kind: "escalate",
        from_name: DOMAIN_OWNERS.IT.name,
        to_name: GOVSUITE_SUPPORT.name,
        reason: "Escalated to Tier 2 — GovSuite product issue.",
      },
    ],
  },
];

// Align hd-3 assignee with last re-route hop for demo consistency
SEED_HELP_TICKETS[2].assignee_id = "emp-ortiz";
SEED_HELP_TICKETS[2].assignee_name = "Jordan Ortiz";
